export const Routes = {
  Login: "/login",
};
